import React from "react";

const ListDisplay = ({ title, list, onClick }) => {
  return (
    <div className="third-sec">
      <h4 className={onClick ? "cp top-products" : ""} onClick={onClick}>
        {title}:
      </h4>
      <span className="product-list">
        {list.length > 150
          ? `${list.replace(/\|\|/g, ",  ").substring(0, 150)} ...`
          : list.replace(/\|\|/g, ",  ")}
      </span>
    </div>
  );
};

export default ListDisplay;
